<page-data-manager>
  <div class="row">
    <div class="col-xs-12" ng-show="usuario.id">
      <div class="panel panel-default no-margin">
        <div class="panel-heading">
          <h4 class="panel-title">Usuário</h4>
        </div>
        <div class="panel-body">
          <p><b>Nome:</b> {{::usuario.nomeCompleto | capitalize}}</p>
          <p><b>Login:</b> {{::usuario.nome}}</p>
          <p><b>CPF:</b> {{::usuario.cpf | formatCPF }}</p>
          <p><b>Email:</b> {{::usuario.email}}</b></p>
          <p><b>Função:</b> <a href="#!/funcoes/{{usuario.funcao.id}}"> {{::usuario.funcao.descricao | humanize}}</a></p>
          <p><b>Utiliza Mobile:</b> {{usuario.utilizaMobile ? 'Sim' : 'Não'}}</p>
          <p><b>Telefone:</b> {{usuario.telefone}}</p>
          <p><b>Propriedades:</b>
            <div class="col-xs-12" ng-repeat="propriedade in usuario.propriedades | orderBy: 'descricao'">
              {{::propriedade.descricao | capitalize}}
              <small ng-show="propriedade.produtor.id" class="text-muted">
                (Produtor: {{::propriedade.produtor.nome | capitalize}})
              </small>
            </div>
          </p>
        </div>
      </div>
      <div>
        <historico-alteracoes id="{{usuario.id}}" type="Usuario" title="Log de alterações" />
      </div>
      <div class="row pull-right padding-top-10" ng-include="'views/usuarios/_show_buttons.html'"></div>
    </div>
  </div>
</page-data-manager>
